jQuery(document).ready(function($) {
    if (!is_dev) {
        return;
    }


    // if ($('body').hasClass('courses/refreshers')) {
    //     open_refresher_invitations_screen();
    //     setTimeout(function() {
    //         let check = setInterval(function() {
    //             if ($('.reveal .scrollable-table input.check-whole-table').length > 0) {
    //                 clearInterval(check);
    //
    //                 $('.reveal .scrollable-table tbody').find('tr[data-id]:nth-child(2), tr[data-id]:nth-child(3), tr[data-id]:nth-child(4)').find('input[type=checkbox]').click();
    //                 setTimeout(function() {
    //                     $('.reveal .scrollable-table tbody').parents('form').submit();
    //                 }, 1000);
    //             }
    //         }, 500);
    //     },2000);
    // }
    // if ($('body').hasClass('calendar')) {
    //     return write_message([378,377,376,1],'course',null,'appointment:99,course:1,appointments_list:appointment.generateMessageAppointmentsList,addresses:appointment.generateAddresses');
    // }
});